import { useParams } from 'react-router-dom'

import { NvvAction } from '../enums/DocActions'

import ReservationNvvDetailPage from './ReservationNvvDetailPage'

const ReservationDetailPage: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()

  return <>{id && <ReservationNvvDetailPage id={id} nvvInd={NvvAction.SoloReserva} />}</>
}
export default ReservationDetailPage
